import Vue from 'vue'; 
import VueRouter from 'vue-router'; 
 import { MessageBox } from "mint-ui";
 import { utils } from './utils/utils';
 
 import store from './store/store'; 
Vue.use(VueRouter)

 const getView = (path) => {   
 return () => import(`./views/${path}.vue`);
};
 
const RouterPush=VueRouter.prototype.push
 
VueRouter.prototype.push=function push(to){ 
    return RouterPush.call(this,to).catch(err=>err)
} 
 

const router = new VueRouter({
     mode:"history",
     //base: '/H5/', 
    routes: [ 
         {
             path : "*",
             name: '',
             redirect: '/index'
         }, {
            path: '/',
            name: '',
             redirect: '/index'
        }, 
        {
            path: '/index',
            name: 'index',
            component: getView('index') 
        },
        {
             path: '/search/:ifyCode*/Vcode/:Vcode*/Value/:Svalue*', 
            name: 'search',
            component: getView('search'),  
        }, {
            path: '/info/:ifyCode*/Guid/:guid*/Sid/:sid*/Year/:years*/Pindex/:pindex*/',
            name: 'info',
            component: getView('info'),
        },
		{
		     path: '/bindex/:ifyCode*/Vcode/:Vcode*/Value/:Svalue*', 
		    name: 'bindex',
		    component: getView('bindex'),
		},
		{
		     path: '/pindex/:ifyCode*/Value/:Svalue*', 
		    name: 'pindex',
		    component: getView('pindex'),
		},
		{
		     path: '/advsearch', 
		    name: 'advsearch', 
            component: getView('advsearch'),
		},
		{
		     path: '/author', 
		    name: 'author', 
            component: getView('author'),
		},
		{
		  path: '/authorInfo/Guid/:guid*',
		    name: 'authorInfo', 
		    component: getView('authorInfo'),
		},
		{
			path: '/Howto/Code/:Code*',
			  name: 'Howto', 
			  component: getView('Howto'),
		},
		{
			path: '/publish',
			  name: 'publish', 
			  component: getView('publish'),
		}
    ],
	  
});

 
router.beforeEach((to, from, next) => {   
	 if (to.name != 'index') {
		
 let userInfo=utils.getssionStorageWithExpiry("#UserInfo")||""; 
        if (userInfo=="") {
			MessageBox.alert("登录过期", "提示").then(() => {
			  
			  router.push('/index')
			});
			return false;
        }
    } 
	 
	if(to.path==from.path){
		next(false)
	}else{
		window.scrollTo(0,0);
    next()
	}
})
 
export default router;
 
